<template>
  <div class="mb-2">
    <v-slide-y-transition>
      <div v-show="!isPDFGenerated">
        <v-btn
          v-show="!value.isGenerating"
          @click="genPDF"
        >
          {{ $t('Outbox.GenUploadFile') }}
        </v-btn>

        <v-slide-y-transition>
          <v-card
            v-show="value.isGenerating"
            max-width="500"
            elevation="12"
            class="mx-auto my-10"
          >
            <v-card-title class="py-6 text-center">
              {{ $t('Outbox.GeneratingUploadFile') }}
              <v-progress-linear
                indeterminate
                height="8"
                color="primary"
              />
            </v-card-title>
          </v-card>
        </v-slide-y-transition>
      </div>
    </v-slide-y-transition>

    <v-slide-y-transition>
      <div v-show="isPDFGenerated">
        <v-btn
          class="mr-2 mb-2"
          @click="previewOficioFileList"
        >
          {{ $t('Outbox.PreviewUploadFile') }}
        </v-btn>
        <v-btn
          v-if="value.refResponse && value.refResponse.length"
          class="mr-2 mb-2"
          @click="previewRefFileList"
        >
          {{ $t('Outbox.PreviewRefDoc') }}
        </v-btn>

        <v-btn
          v-show="!$config.isApp"
          rounded
          outlined
          class="mr-2 mb-2 float-sm-right"
          @click="downloadOficioPdfZip"
        >
          <v-icon>{{ mdiFileDownloadOutline }}</v-icon>
          {{ $t('Outbox.downloadOficioZip') }}
        </v-btn>
        <!-- <s-show-img
        v-model="dialog"
        :files="files"
      /> -->
        <s-class-pdf-muti
          v-model="dialog"
          :file-ctxs="files"
        />
        <br><br>
        <div v-if="value.isEncryptDoc && $config.isEncryptDynamicFlow">
          <div class="caption grey--text">
            {{ $t('eDocInternal.encryptedFileViewerStaff2') }}
          </div>
          <div
            class="text-body-2 pa-2 grey lighten-4 grey--text text--darken-2 rounded"
            style="border-bottom: 1px solid #333"
          >
            {{ openers }}
          </div>
          <s-search-staff-muti
            v-model="value.newOpenersEuid"
            :label="$t('eDocInternal.encryptedFileViewerStaff.add2')"
            @dataChange="value.newOpenersObj = $event"
          />
          <br><br>
        </div>
        <v-autocomplete
          v-model="local.issueSubunitEntityId"
          :items="issueSubunitEntity"
          item-value="id"
          :item-text="item => item.abbr + '-' + $chPtObjData('chinName', item)"
          hide-details
          :label="$t('Outbox.IssueSubunitEntity')"
        />
        <br><br>
        <s-search-staff
          :disabled="value.isEncryptDoc && !$config.isEncryptDynamicFlow"
          :select.sync="local.nextStaff"
          :staff.sync="local.nextStaffObj"
          :label="$t('Outbox.NextStaff')"
          show-support-staff
          show-group
        />
        <v-switch
          v-model="local.isDirectSendToEDocX"
          :label="$t('Outbox.DirectSendAfterSign')"
          class="d-inline-block ml-1 mr-6"
        />
        <v-switch
          v-model="local.isUrgent"
          :label="$t('Outbox.Urgent')"
          class="d-inline-block"
        />

        <br>
        <v-btn
          color="primary"
          :loading="loading"
          @click="insertNewOficio"
        >
          {{ $t('Outbox.Present') }}
        </v-btn>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import SSearchStaff from '@/components/SSearchStaff'
import SClassPdfMuti from '@/components/SClassPdfMuti'
// import SShowImg from '@/components/SShowImg'
import outboxApi from '@/api/outbox/outbox'
import jwtTokenApi from '@/api/general/jwtToken'
import { globalModule } from '@/store/moduleName'
import stringUtil from '@/utils/stringUtil'
import { OUTBOX_ENTITY_SOURCE_TYPE, OUTBOX_FILE_TYPE, OUTBOX_REPLY_DOC_CNT } from '@/constant/constant'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { getArraySorter, isArrayEmptyOrNull, removeDuplicates } from '@/utils/arrayUtil'
import { mdiFileDownloadOutline } from '@mdi/js'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'
import CryptoUtil from '@/lib/g2e/CryptoUtil.js'
import { commonComponentModule } from '@/store/moduleName.js'
import { encryptMethod } from '@/mixins/encryptMethod'
import SSearchStaffMuti from '@/components/SSearchStaffMuti.vue'

function getEntityIdStr (selectedEntities) {
  let entityIds = []
  selectedEntities.forEach(element => {
    entityIds.push(element.split('-')[1])
  })
  return entityIds.join()
}

function getIssueSubunitEntity (inst) {
  outboxApi.getIssueSubunitEntity(resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.issueSubunitEntity = resp.data
      inst.issueSubunitEntity.some(subEntity => {
        if (subEntity.isDefault) {
          inst.value.issueSubunitEntityId = subEntity.id
          return true
        }
      })
    }
  })
}

export default {
  components: {
    SClassPdfMuti,
    // SShowImg,
    SSearchStaff,
    SSearchStaffMuti
  },
  mixins: [encryptMethod],
  props: {
    value: {
      type: Object,
      default: null
      // {
      //   ...
      //   nextStaff
      // },
    }
  },
  data: () => {
    return {
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      loading: false,
      dialog: false,
      // displayFile: null,
      fileStream: null,
      files: [],
      issueSubunitEntity: []
    }
  },
  computed: {
    openers () {
      let result = ''
      this.value.openerList.forEach(opener => {
        if (!stringUtil.isFieldBlank(result)) {
          result = result + ', '
        }
        let blank = ''
        if (!stringUtil.isFieldBlank(opener.chinName) && !stringUtil.isFieldBlank(opener.portName)) {
          blank = ' '
        }
        result = result + stringUtil.nvl(opener.chinName, '') + blank + stringUtil.nvl(opener.portName, '')
      })
      return result
    },
    isPDFGenerated () {
      return this.value.isOficioPDFGenerated && this.value.isInterpellationPDFGenerated
    },
    local () {
      return this.value ? this.value : {
        nextStaff: null,
        isUrgent: false
      }
    },
    selectedEntityObjs () {
      let result = []
      this.value.watchProps.selectedEntities.forEach(id => {
        let entityId = parseInt(id.split('-')[1])
        let entity = this.value.groupEntities.find(element => element.id === entityId)
        if (entity) { result.push(entity) }
      })
      return result
    }
  },
  watch: {
    'value.newOpenersObj': {
      handler: async function (val) {
        this.loading = true
        await this.checkAndShowNoKeyPairUser(val)
        this.loading = false
      }
    },
    deep: true
    // displayFile: function (val) {
    //   outboxApi.downloadFile(val.documentCode, val.uploadFileId, resp => {
    //     if (resp.status === 201 || resp.status === 200) {
    //       this.fileStream = resp.data
    //     }
    //   })
    // }
  },
  created () {
    getIssueSubunitEntity(this)
    if (this.value.myPublicKey) {
      this.value.newOpenersEuid.push(parseJwt(getStorage('g2e-jwt-token')).euid)
    }
  },
  methods: {
    async getMyEncryptedFileKey () {
      if (this.value.filePassword && this.value.myPublicKey) {
        let encryptedFileKey = await CryptoUtil.PGPTool.encryptText(this.value.filePassword, this.value.myPublicKey)
        return encryptedFileKey
      } else {
        return null
      }
    },
    update (key, value) {
      this.value.nextStaff = value
      // this.$emit('input', { ...this.local, [key]: value })
    },
    getSendDate () {
      let sendDates = null
      if (this.value.watchProps.isReply) {
        sendDates = []
        for (let i = 0; i < OUTBOX_REPLY_DOC_CNT; i++) {
          if (this.value.watchProps.sendDate[i]) {
            sendDates.push(this.value.watchProps.sendDate[i])
          } else if (!this.value.watchProps.sendDate[i] && this.value.watchProps.senderOficioNo[i]) {
            sendDates.push('')
          }
        }
      }
      return sendDates
    },
    getSenderOficioNo () {
      let senderOficioNos = null
      if (this.value.watchProps.isReply) {
        senderOficioNos = []
        for (let i = 0; i < OUTBOX_REPLY_DOC_CNT; i++) {
          if (this.value.watchProps.senderOficioNo[i]) {
            senderOficioNos.push(this.value.watchProps.senderOficioNo[i])
          } else if (!this.value.watchProps.senderOficioNo[i] && this.value.watchProps.sendDate[i]) {
            senderOficioNos.push('')
          }
        }
      }
      return senderOficioNos
    },
    async genPDF () {
      if (!this.value.watchProps.docNo) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.OficioNo')]))
        return false
      }
      if (this.value.watchProps.selectedEntities.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.ReceiveDept')]))
        return false
      }
      if (this.value.watchProps.oficioDocResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Outbox.OficioDoc')]))
        return false
      }
      if (!this.value.title) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.OficioTitle')]))
        return false
      }
      if (!this.value.signer) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.Signer')]))
        return false
      }
      this.value.isGenerating = true

      let mergeAttachments = []
      for (let i = 0; i < this.value.watchProps.mergePdfResponse.length; i++) {
        const resp = this.value.watchProps.mergePdfResponse[i]
        mergeAttachments.push({
          instanceCode: resp.response.instanceCode,
          uploadFileId: resp.response.id
        })
      }
      // gen pdf for oficio doc
      outboxApi.mailMergeOficioPDF_v2(this.value.issueEntityId, this.value.watchProps.ccEntities.join(), getEntityIdStr(this.value.watchProps.selectedEntities), OUTBOX_ENTITY_SOURCE_TYPE.APM,
        this.value.watchProps.oficioDocResponse[0].response.instanceCode, this.value.watchProps.labelTypeId, this.value.watchProps.docNo,
        this.value.watchProps.oficioDocResponse[0].response.id, this.getSendDate(), this.getSenderOficioNo(), mergeAttachments, resp => {
          this.value.isOficioPDFGenerated = false
          if (resp.status === 201 || resp.status === 200) {
            this.value.oficioPdfResponse = resp.data
            this.value.isOficioPDFGenerated = true
            // this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Outbox.GenUploadFile.Success'))
          }
        })
      // gen pdf for Interpellation doc
      if (isArrayEmptyOrNull(this.value.watchProps.interpellationDocResponse)) {
        this.value.isInterpellationPDFGenerated = true
      } else {
        this.value.isInterpellationPDFGenerated = false
        this.value.interpellationPdfResponse = []
        for (let i = 0; i < this.value.watchProps.interpellationDocResponse.length; i++) {
          let docResp = this.value.watchProps.interpellationDocResponse[i]
          await outboxApi.mailMergeOficioPDF_v2(this.value.issueEntityId, '', getEntityIdStr(this.value.watchProps.selectedEntities), OUTBOX_ENTITY_SOURCE_TYPE.APM,
            docResp.response.instanceCode, this.value.watchProps.labelTypeId, this.value.watchProps.docNo,
            docResp.response.id, this.getSendDate(), this.getSenderOficioNo(), [], resp => {
              if (resp.status === 201 || resp.status === 200) {
                this.value.interpellationPdfResponse.push(resp.data)
              }
            })
        }
        this.value.isInterpellationPDFGenerated = true
      }
    },
    async getEncryptedReceivers (attachResponse) {
      if (this.value.isEncryptDoc) {
        let encryptedReceivers = []
        let hasError = false
        let receiverOpenerList = []
        let selectedEntityIds = getEntityIdStr(this.value.watchProps.selectedEntities).split(',')
        await outboxApi.getEDocXEuidListBySecurityLevelId(selectedEntityIds, this.value.securityLevel, resp => {
          if (resp.status === 201 || resp.status === 200) {
            receiverOpenerList = resp.data
          }
        })
        if (hasError) {
          throw new Error('error in getting euid list by security level')
        }
        let senderOpenerList = []
        let senderEuids = []
        if (this.$config.isEncryptDynamicFlow) {
          let defaultOpenerEuids = this.value.openerList.map((opener) => opener.euid)
          senderEuids = [...defaultOpenerEuids, ...this.value.newOpenersEuid]
        } else {
          senderEuids.push(parseJwt(getStorage('g2e-jwt-token')).euid)
          senderEuids.push(this.value.signer)
        }
        await jwtTokenApi.getPublicKeys(senderEuids, resp => {
          if (resp.status === 201 || resp.status === 200) {
            senderOpenerList = resp.data
          }
        })
        if (hasError) {
          throw new Error('error in getting public keys')
        }
        for (const opener of senderOpenerList) {
          if (opener.publicKey) {
            let encryptedKey = await CryptoUtil.PGPTool.encryptText(this.value.filePassword, opener.publicKey)
            encryptedReceivers.push({
              encryptedKey: encryptedKey,
              entityId: parseJwt(getStorage('g2e-jwt-token')).entity_id,
              euid: opener.euid,
              publicKeyId: opener.id

            })
          }
        }
        for (const opener of receiverOpenerList) {
          if ((attachResponse.response.entityId === null) || (attachResponse.response.entityId === opener.originalEntityId)) {
            for (const user of opener.users) {
              if (user.publicKey) {
                let encryptedKey = await CryptoUtil.PGPTool.encryptText(this.value.filePassword, user.publicKey)
                encryptedReceivers.push({
                  encryptedKey: encryptedKey,
                  entityId: opener.entityId,
                  euid: user.euid,
                  publicKeyId: user.publicKeyId
                })
              }
            }
          }
        }
        return encryptedReceivers
      } else {
        return null
      }
    },
    async checkEncryptedReceivers (attachResps) {
      let securityOpenerList = []
      let missingEntityIds = []
      if (this.value.isEncryptDoc) {
        let entityIds = []
        attachResps.every(resp => {
          if (resp.response.entityId === null) {
            entityIds = getEntityIdStr(this.value.watchProps.selectedEntities).split(',')
            return false
          } else {
            entityIds.push(resp.response.entityId)
          }
          return true
        })
        entityIds = removeDuplicates(entityIds)
        securityOpenerList = await this.getSecurityOpenerList(entityIds, this.value.securityLevel)
        missingEntityIds = this.getMissSecurityList(entityIds, securityOpenerList)
      }

      return missingEntityIds
    },
    async insertNewOficio () {
      this.loading = true
      try {
        if (!this.value.watchProps.docNo) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.OficioNo')]))
          throw new Error()
        }
        if (!this.value.title) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.OficioTitle')]))
          throw new Error()
        }
        if ((this.value.issueEntities.length > 0) && (this.value.issueEntityId === null)) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.IssueEntity')]))
          throw new Error()
        }
        if (!this.value.signer) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.Signer')]))
          throw new Error()
        }
        if (!this.value.issueSubunitEntityId) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.IssueSubunitEntity')]))
          throw new Error()
        }
        if (!this.value.nextStaff) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.NextStaff')]))
          throw new Error()
        }
        let missAttachEntity = this.value.attachResponse.some(resp => {
          if (resp.response.entityId) {
            let func = (entity) => {
              return (parseInt(entity.split('-')[1]) === resp.response.entityId)
            }
            return !this.value.watchProps.selectedEntities.some(func)
          }
        })
        if (missAttachEntity) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.AttachmentEntity')]))
          throw new Error()
        }
        if (this.value.watchProps.ccEntities.length > 0 && !this.value.carbonCopyFromEntityId) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.CCFromEntity'))
          throw new Error()
        }
        if (this.value.isEncryptDoc && isArrayEmptyOrNull(this.value.attachResponse)) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('encrypt.encryptedAttachment')]))
          throw new Error()
        }
        let missingEntityIds = []
        try {
          missingEntityIds = await this.checkEncryptedReceivers(this.value.attachResponse)
        } catch (e) {
          console.error(e)
          throw new Error()
        }
        if (!isArrayEmptyOrNull(missingEntityIds)) {
          let missingEntities = []
          missingEntityIds.forEach(entityId => {
            let entity = this.selectedEntityObjs.find(entity => (entity.id + '') === (entityId + ''))
            if (entity) { missingEntities.push(entity) }
          })
          let entityNames = ''
          missingEntities.forEach(entity => {
            if (entityNames) { entityNames = entityNames + ', ' }
            entityNames = entityNames + this.$chPtObjData('chinName', entity)
          })
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('encrypt.error.noReceiver', [entityNames]))
          throw new Error()
        }
        if (this.value.isEncryptDoc && this.$config.isEncryptDynamicFlow) {
          if (await this.checkAndShowNoKeyPairUser(this.value.newOpenersObj)) {
            throw new Error()
          }
        }

        let attachments = []
        for (let i = 0; i < this.value.attachResponse.length; i++) {
          const resp = this.value.attachResponse[i]
          let encryptedReceivers = null
          try {
            encryptedReceivers = await this.getEncryptedReceivers(resp)
          } catch (e) {
            console.error(e)
            throw new Error()
          }
          attachments.push({
            encryptedReceivers: encryptedReceivers,
            displayName: stringUtil.filename(resp.name),
            entityId: resp.response.entityId,
            entitySourceTypeId: 1,
            fileExtension: stringUtil.fileExt(resp.name),
            instanceCode: resp.response.instanceCode,
            uploadFileId: resp.response.id
          })
        }

        let oficios = []
        let oficioDocFilename = stringUtil.filename(this.value.watchProps.oficioDocResponse[0].name)
        for (let i = 0; i < this.value.oficioPdfResponse.length; i++) {
          const resp = this.value.oficioPdfResponse[i]
          oficios.push({
            displayName: oficioDocFilename,
            entityId: resp.entityId,
            entitySourceTypeId: 1,
            fileExtension: 'pdf',
            instanceCode: resp.instanceCode,
            uploadFileId: resp.id
          })
        }

        let references = []
        for (let i = 0; i < this.value.refResponse.length; i++) {
          const resp = this.value.refResponse[i]
          references.push({
            displayName: stringUtil.filename(resp.name),
            fileExtension: stringUtil.fileExt(resp.name),
            instanceCode: resp.response.instanceCode,
            uploadFileId: resp.response.id
          })
        }

        let mergeAttachments = []
        for (let i = 0; i < this.value.watchProps.mergePdfResponse.length; i++) {
          const resp = this.value.watchProps.mergePdfResponse[i]
          mergeAttachments.push({
            instanceCode: resp.response.instanceCode,
            uploadFileId: resp.response.id
          })
        }

        let oficioDocFileExt = stringUtil.fileExt(this.value.watchProps.oficioDocResponse[0].name)
        let data = {
          attachments: attachments,
          isUrgent: this.value.isUrgent,
          isDirectSendToEDocX: this.value.isDirectSendToEDocX,
          labelTypeId: this.value.watchProps.labelTypeId,
          lang: this.$i18n.locale,
          oficioDocDisplayName: oficioDocFilename,
          oficioDocFileExtension: oficioDocFileExt,
          oficioDocInstanceCode: this.value.watchProps.oficioDocResponse[0].response.instanceCode,
          oficioDocUploadFileId: this.value.watchProps.oficioDocResponse[0].response.id,
          oficioTypeId: this.value.docTypesId,
          oficios: oficios,
          mergeAttachments: mergeAttachments,
          refDocNo: this.value.watchProps.docNo,
          references: references,
          replyDate: this.getSendDate(),
          replyRefDocNo: this.getSenderOficioNo(),
          signer: this.value.signer,
          title: this.value.title,
          issueSubunitEntityId: this.value.issueSubunitEntityId,
          isCarbonCopyAttachments: this.value.isCarbonCopyAttachments,
          carbonCopyFromEntityId: this.value.carbonCopyFromEntityId,
          isEncryptedDoc: this.value.isEncryptDoc,
          securityLevelId: this.value.isEncryptDoc ? this.value.securityLevel : null
        }

        if (!isArrayEmptyOrNull(this.value.watchProps.interpellationDocResponse)) {
          let signAttachment = []
          for (let j = 0; j < this.value.watchProps.interpellationDocResponse.length; j++) {
            const docResp = this.value.watchProps.interpellationDocResponse[j]
            let signAttachmentFilename = stringUtil.filename(docResp.name)
            let signAttachmentDetails = []
            for (let i = 0; i < this.value.interpellationPdfResponse[j].length; i++) {
              const resp = this.value.interpellationPdfResponse[j][i]
              signAttachmentDetails.push({
                pdfDisplayName: signAttachmentFilename,
                pdfFileExtension: 'pdf',
                pdfInstanceCode: resp.instanceCode,
                pdfUploadFileId: resp.id,
                receiveEntityId: resp.entityId,
                receiveEntitySourceTypeId: 1
              })
            }

            signAttachment.push({
              details: signAttachmentDetails,
              wordDisplayName: signAttachmentFilename,
              wordFileExtension: stringUtil.fileExt(docResp.name),
              wordInstanceCode: docResp.response.instanceCode,
              wordUploadFileId: docResp.response.id
            })
          }

          data.signAttachment = signAttachment
        }

        // if (this.value.nextStaffObj.recordType && (this.value.nextStaffObj.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
        if (this.value.nextStaff && !this.value.nextStaff.startsWith('E')) {
          data.handlerGroupId = this.value.nextStaff
        } else {
          data.handler = this.value.nextStaff
        }
        if (this.value.issueEntities.length > 0) {
          data.issueEntityId = this.value.issueEntityId
        }
        if (this.value.watchProps.ccEntities.length > 0) {
          data.carbonCopyEntities = []
          this.value.watchProps.ccEntities.forEach(ccEntityId => {
            data.carbonCopyEntities.push({
              entityId: ccEntityId,
              entitySourceTypeId: 1
            })
          })
        }
        outboxApi.insertNewOficio_v2(data, resp => {
          this.loading = false
          if (resp.status === 201 || resp.status === 200) {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.Upload.Success'))
            this.$emit('uploadSuccess')
          }
        })
      } catch {
        this.loading = false
        return false
      }
    },
    // preview files not yet in task list
    previewFileList (data) {
      outboxApi.previewOficioFileList(data, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.files = []
          let respData = resp.data
          respData.sort(getArraySorter('listOrder', true))
          for (let i = 0; i < respData.length; i++) {
            const e = respData[i]
            let pdfInitParams = {
              url: this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/downloadFile?instanceCode=' + e.documentCode + '&uploadFileId=' + e.uploadFileId,
              httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
              withCredentials: true,
              CMapReaderFactory
            }
            e.url = pdfInitParams
            this.files.push(e)
          }
          this.dialog = true
        }
      })
    },
    // preview files not yet in task list
    previewRefFileList () {
      let references = []
      for (let i = 0; i < this.value.refResponse.length; i++) {
        const resp = this.value.refResponse[i]
        references.push({
          entityId: resp.response.entityId,
          entitySourceTypeId: 1,
          fileExtension: stringUtil.fileExt(resp.name),
          fileTypeId: OUTBOX_FILE_TYPE.REFERENCE,
          instanceCode: resp.response.instanceCode,
          title: stringUtil.filename(resp.name),
          uploadFileId: resp.response.id
        })
      }

      this.previewFileList(references)
    },
    // preview files not yet in task list
    async previewOficioFileList () {
      let oficios = []
      let oficioDocFilename = stringUtil.filename(this.value.watchProps.oficioDocResponse[0].name)
      for (let i = 0; i < this.value.oficioPdfResponse.length; i++) {
        const resp = this.value.oficioPdfResponse[i]
        oficios.push({
          entityId: resp.entityId,
          entitySourceTypeId: 1,
          fileExtension: 'pdf',
          fileTypeId: OUTBOX_FILE_TYPE.OFICIO,
          instanceCode: resp.instanceCode,
          title: oficioDocFilename,
          uploadFileId: resp.id
        })
      }

      let interpellations = []
      if (!isArrayEmptyOrNull(this.value.watchProps.interpellationDocResponse)) {
        for (let j = 0; j < this.value.watchProps.interpellationDocResponse.length; j++) {
          let interpellationDocFilename = stringUtil.filename(this.value.watchProps.interpellationDocResponse[j].name)
          let pdfResp = this.value.interpellationPdfResponse[j]
          for (let i = 0; i < pdfResp.length; i++) {
            const resp = pdfResp[i]
            interpellations.push({
              entityId: resp.entityId,
              entitySourceTypeId: 1,
              fileExtension: 'pdf',
              fileTypeId: OUTBOX_FILE_TYPE.INTERPELLATION,
              instanceCode: resp.instanceCode,
              title: interpellationDocFilename,
              uploadFileId: resp.id
            })
          }
        }
      }

      if (this.value.isEncryptDoc) {
        let encryptedFileKey = await this.getMyEncryptedFileKey()
        this.$store.commit(commonComponentModule + '/setEncryptedFileKey', encryptedFileKey)
        this.$store.commit(commonComponentModule + '/setKeyPairId', this.value.myKeyPairId)
      }
      let attachments = []
      for (let i = 0; i < this.value.attachResponse.length; i++) {
        const resp = this.value.attachResponse[i]
        attachments.push({
          entityId: resp.response.entityId,
          entitySourceTypeId: 1,
          fileExtension: stringUtil.fileExt(resp.name),
          fileTypeId: OUTBOX_FILE_TYPE.ATTACHMENT,
          instanceCode: resp.response.instanceCode,
          title: stringUtil.filename(resp.name),
          uploadFileId: resp.response.id
        })
      }

      let data = [...oficios, ...interpellations, ...attachments]
      this.previewFileList(data)
    },
    downloadOficioPdfZip () {
      let body = []
      let oficioDocFilename = stringUtil.filename(this.value.watchProps.oficioDocResponse[0].name)
      for (let i = 0; i < this.value.oficioPdfResponse.length; i++) {
        const resp = this.value.oficioPdfResponse[i]
        body.push({
          entityId: resp.entityId,
          entitySourceTypeId: 1,
          fileExtension: 'pdf',
          fileTypeId: OUTBOX_FILE_TYPE.OFICIO,
          instanceCode: resp.instanceCode,
          title: oficioDocFilename,
          uploadFileId: resp.id
        })
      }
      outboxApi.downloadOficioPdfZip(body, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          let disposition = resp.headers['content-disposition']
          let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          link.setAttribute('download', filename)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    }
  }
}
</script>
